import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { map, take } from 'rxjs/operators';
import * as fromRoot from '@core/redux/index';

@Injectable()
export class GuardAdminReportsService implements CanActivate {
  constructor(
    private router: Router,
    private store: Store<fromRoot.State>,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.store
      .pipe(
        select(fromRoot.getAuthUser),
        map((user) => {
          const canAccessReports = !!(user && user.permissions && user.permissions.inviteCrud);
          if (canAccessReports) {
            return true;
          }

          const companyId = route.params && route.params.company;
          if (companyId) {
            this.router.navigate(['/', companyId, 'wiki']);
          } else {
            this.router.navigate(['/dashboard']);
          }

          return false;
        }),
        take(1),
      );
  }
}
